<div class="signature-pad">
  <h5 class="signature-pad-title">Firma del Asegurado</h5>

  <!-- Canvas stays in the DOM (display toggled) so the ViewChild/context stay
       valid across save/clear; removing it with *ngIf breaks the ref. -->
  <div class="canvas-container" [style.display]="signatureImage ? 'none' : 'flex'">
    <canvas
      #canvas
      (mousedown)="startDrawing($event)"
      (mousemove)="draw($event)"
      (mouseup)="endDrawing()"
      (mouseleave)="endDrawing()"
      (touchstart)="startDrawing($event)"
      (touchmove)="draw($event)"
      (touchend)="endDrawing()">
    </canvas>
  </div>

  <div class="signature-preview" *ngIf="signatureImage">
    <p>Firma registrada</p>
    <img [src]="signatureImage" alt="Firma" />
  </div>

  <div class="signature-actions">
    <button class="btn secundary-btn min-width-btn" type="button" (click)="deleteDraw()">
      Limpiar
    </button>
    <button
      *ngIf="!signatureImage"
      class="btn secundary-btn min-width-btn"
      type="button"
      (click)="saveAsImage()">
      Guardar Firma
    </button>
  </div>
</div>
